var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v("Виджет онлайн записи")]),_vm._v(" Откроем виджет через 3 секунды ")])
}]

export { render, staticRenderFns }